<template>
  <div class="free-spins_wrapper">
    <img :src="getIconUrl" :style="styleIcon" alt="" />
    <div class="progress">{{ leftRounds }}/{{ totalRounds }}</div>
    <div class="total-win">{{ $t('progress_bar.total_win') }}: {{ wins }}</div>
  </div>
</template>

<script lang="ts">
import Vue from 'vue';
import { mapGetters } from 'vuex';

export default Vue.extend({
  name: 'FreeSpinProgress',
  computed: {
    ...mapGetters([
      'getReward',
      'getAmountLeftSpinsAchievement',
      'getRewardTournament',
      'hasAchievement',
      'hasFreeSpinsTournament',
      'getCurrentLeftSpinsFreeRounds',
      'getAmountSpinsFreeRounds',
      'isFreeRounds',
      'getFreeRoundsWins'
    ]),
    wins(): string {
      return this.getFreeRoundsWins || this.getReward.wins || this.getRewardTournament.wins;
    },
    totalRounds(): number {
      return this.getAmountSpinsFreeRounds || this.getReward.rounds || this.getRewardTournament.rounds;
    },
    leftRounds(): number {
      if (this.isFreeRounds) return this.getCurrentLeftSpinsFreeRounds;
      if (this.hasAchievement)
        return this.getAmountLeftSpinsAchievement === null ? 0 : this.totalRounds - this.getAmountLeftSpinsAchievement;
      return this.getRewardTournament.roundsLeft === null ? 0 : this.totalRounds - this.getRewardTournament.roundsLeft;
    },
    getIconUrl(): string {
      return `${__PROMO_CONFIG.STATIC_URL}/assets/img/progress/fs_${
        this.hasFreeSpinsTournament ? 'tournaments' : 'achievements'
      }_icon.png`;
    },
    styleIcon(): { width: string } {
      const width: number = this.hasFreeSpinsTournament ? 50 : 62;
      return {
        width: width + 'px'
      };
    }
  }
});
</script>

<style scoped>
.free-spins_wrapper {
  display: flex;
  align-items: center;
  color: white;
  font-size: 24px;
  font-family: myriadpro-regular, sans-serif;
}

.progress {
  margin-left: 5px;
}

.total-win {
  margin-left: 15px;
  line-height: 25px;
  text-align: center;
}
</style>
